"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnotationItemListView = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var utils_1 = require("../../../utils");
var icon_definitions_1 = require("../atoms/icon-definitions");
var Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  user-select: none;\n  -webkit-touch-callout: none;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  user-select: none;\n  -webkit-touch-callout: none;\n"])));
var Title = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  flex-grow: 0;\n  padding: 10px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  flex-grow: 0;\n  padding: 10px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n"])));
var List = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  flex-grow: 1;\n  width: 100%;\n"], ["\n  flex-grow: 1;\n  width: 100%;\n"])));
var backgroundColor = {
    selected: (0, utils_1.rgbToStr)([200, 200, 200]),
    highlighted: (0, utils_1.rgbToStr)([235, 235, 235]),
    inactive: (0, utils_1.rgbToStr)([255, 255, 255])
};
var ListItemBase = styled_components_1.default.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  padding: 10px;\n  background-color: white;\n"], ["\n  padding: 10px;\n  background-color: white;\n"])));
var ListButtonItem = (0, styled_components_1.default)(ListItemBase)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  &:hover {\n    opacity: 0.7;\n    background-color: ", ";\n  }\n  cursor: pointer;\n"], ["\n  &:hover {\n    opacity: 0.7;\n    background-color: ", ";\n  }\n  cursor: pointer;\n"])), backgroundColor.highlighted);
var ListItemDisabled = (0, styled_components_1.default)(ListItemBase)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  color: rgba(0, 0, 0, 0.26);\n  background-color: rgba(0, 0, 0, 0.08);\n"], ["\n  color: rgba(0, 0, 0, 0.26);\n  background-color: rgba(0, 0, 0, 0.08);\n"])));
exports.AnnotationItemListView = (0, react_1.memo)(function (_a) {
    var list = _a.list, onClick = _a.onClick, onHover = _a.onHover, selectedId = _a.selectedId, highlightId = _a.highlightId, hidden = _a.hidden, onHiddenChange = _a.onHiddenChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b, title = _a.title;
    var onMouseLeave = (0, react_1.useCallback)(function () {
        onHover(undefined);
    }, [onHover]);
    var displayClick = (0, react_1.useCallback)(function () {
        onHiddenChange(false);
    }, [onHiddenChange]);
    var hideClick = (0, react_1.useCallback)(function () {
        onHiddenChange(true);
    }, [onHiddenChange]);
    var listWithHandler = (0, react_1.useMemo)(function () {
        return list.map(function (item) {
            var color = {
                backgroundColor: item.id === selectedId
                    ? backgroundColor.selected
                    : item.id === highlightId
                        ? backgroundColor.highlighted
                        : backgroundColor.inactive
            };
            var onClickHandler = function () {
                // flip
                if (selectedId === item.id) {
                    onClick(undefined);
                }
                else {
                    onClick(item.id);
                }
            };
            var onMouseEnterHandler = function () {
                onHover(item.id);
            };
            return (0, utils_1.t)(item.id, item.displayName, color, onClickHandler, onMouseEnterHandler);
        });
    }, [list, selectedId, highlightId, onClick, onHover]);
    var listStyle = (0, react_1.useMemo)(function () {
        return hidden
            ? { overflowY: 'hidden', maxHeight: '0' }
            : { overflowY: 'auto', maxHeight: 'none' };
    }, [hidden]);
    return (react_1.default.createElement(Root, { onMouseLeave: onMouseLeave },
        react_1.default.createElement(Title, null,
            title,
            hidden ? (react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: displayClick },
                react_1.default.createElement(icon_definitions_1.ExpandListIcon, { fontSize: 'inherit' }))) : (react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: hideClick },
                react_1.default.createElement(icon_definitions_1.CollapseListIcon, { fontSize: 'inherit' })))),
        react_1.default.createElement(List, { style: listStyle }, disabled
            ? listWithHandler.map(function (_a, index) {
                var _b = tslib_1.__read(_a, 2), id = _b[0], displayName = _b[1];
                return (react_1.default.createElement(ListItemDisabled, { key: id },
                    index + 1,
                    ". ",
                    displayName));
            })
            : listWithHandler.map(function (_a, index) {
                var _b = tslib_1.__read(_a, 5), id = _b[0], displayName = _b[1], color = _b[2], onClickHandler = _b[3], onMouseEnterHandler = _b[4];
                return (react_1.default.createElement(ListButtonItem, { style: color, key: id, onClick: onClickHandler, onMouseEnter: onMouseEnterHandler },
                    index + 1,
                    ". ",
                    displayName));
            }))));
});
exports.AnnotationItemListView.displayName = 'AnnotationItemListView';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
